import React from 'react';
import type { AdminProductListItemProps } from '../../interfaces';
import { getFilteredSizes } from '../adminProductForm.utils';
import AdminProductHeader from './AdminProductHeader';
import AdminProductMaterialCollapse from './AdminProductMaterialCollapse';
import { getProductInventorySummary } from './adminProductListItem.utils';
import './AdminProductListItem.scss';

const AdminProductListItem: React.FC<AdminProductListItemProps> = (props) => {
  const { product, deletingProductId, sizes, onDeleteProduct } = props;
  const requiresSizes = product.productType?.requiresSizes ?? true;
  const filteredSizes = getFilteredSizes(
    sizes,
    product.gender,
    product.productType?.name,
    requiresSizes
  );
  const inventorySummary = getProductInventorySummary(product, requiresSizes);

  return (
    <div className="admin-product-form__product-card">
      <AdminProductHeader
        product={product}
        deletingProductId={deletingProductId}
        inventorySummary={inventorySummary}
        onDeleteProduct={onDeleteProduct}
      />
      <AdminProductMaterialCollapse
        {...props}
        filteredSizes={filteredSizes}
        requiresSizes={requiresSizes}
      />
    </div>
  );
};

export default AdminProductListItem;
